import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Row, Col, ButtonToolbar, ToggleButtonGroup, ToggleButton } from 'react-bootstrap';
import { isObject as _isObject } from 'lodash';

import { formStatusDispatchHelper } from 'actions/FormStatusActions';
import { addNotification } from 'actions/NotificationsActions';
import { getThumbFileFromEntity } from 'helpers/items';

import EntityPropsUpdater from 'component/EntityPropsUpdater';

import FormImageWithPreview from 'components/forms/FormImageWithPreview';
import FormSwitchery from 'components/forms/FormSwitchery';

import WhiteLabelFavicons from 'components/layout/whiteLabel/WhiteLabelFavicons';

class WhiteLabelLogoAndFav extends EntityPropsUpdater {
  componentDidUpdate = prevProps => {
    const {
      intl: { messages },
      entity,
      formStatusMainLogo,
      formStatusMainLogoSvg,
      formStatusWatermarkLogo,
      formStatusWatermarkLogoSvg,
      formStatusScrollLogo,
      formStatusScrollLogoSvg,
      formStatusMailLogo,
      doNotify,
    } = this.props;
    const fileUploadedMessage = messages.file_uploaded;

    if (prevProps.formStatusMainLogo.pending && !formStatusMainLogo.pending && !formStatusMainLogo.hasError) {
      // image has been uploaded, update the entity
      const value = entity.createValue('mainLogo', [], formStatusMainLogo.response);
      this.updateEntity('mainLogo', value, [], null, false);

      doNotify(1, fileUploadedMessage);
    }

    if (prevProps.formStatusMainLogoSvg.pending && !formStatusMainLogoSvg.pending && !formStatusMainLogoSvg.hasError) {
      // image has been uploaded, update the entity
      const value = entity.createValue('mainLogoSvg', [], formStatusMainLogoSvg.response);
      this.updateEntity('mainLogoSvg', value, [], null, false);

      doNotify(1, fileUploadedMessage);
    }

    if (prevProps.formStatusWatermarkLogo.pending && !formStatusWatermarkLogo.pending && !formStatusWatermarkLogo.hasError) {
      // image has been uploaded, update the entity
      const value = entity.createValue('watermarkLogo', [], formStatusWatermarkLogo.response);
      this.updateEntity('watermarkLogo', value, [], null, false);

      doNotify(1, fileUploadedMessage);
    }

    if (prevProps.formStatusWatermarkLogoSvg.pending && !formStatusWatermarkLogoSvg.pending && !formStatusWatermarkLogoSvg.hasError) {
      // image has been uploaded, update the entity
      const value = entity.createValue('watermarkLogoSvg', [], formStatusWatermarkLogoSvg.response);
      this.updateEntity('watermarkLogoSvg', value, [], null, false);

      doNotify(1, fileUploadedMessage);
    }

    if (prevProps.formStatusScrollLogo.pending && !formStatusScrollLogo.pending && !formStatusScrollLogo.hasError) {
      // image has been uploaded, update the entity
      const value = entity.createValue('scrollLogo', [], formStatusScrollLogo.response);
      this.updateEntity('scrollLogo', value, [], null, false);

      doNotify(1, fileUploadedMessage);
    }

    if (
      prevProps.formStatusScrollLogoSvg.pending &&
      !formStatusScrollLogoSvg.pending &&
      !formStatusScrollLogoSvg.hasError
    ) {
      // image has been uploaded, update the entity
      const value = entity.createValue('scrollLogoSvg', [], formStatusScrollLogoSvg.response);
      this.updateEntity('scrollLogoSvg', value, [], null, false);

      doNotify(1, fileUploadedMessage);
    }

    if (prevProps.formStatusMailLogo.pending && !formStatusMailLogo.pending && !formStatusMailLogo.hasError) {
      // image has been uploaded, update the entity
      const value = entity.createValue('mailLogo', [], formStatusMailLogo.response);
      this.updateEntity('mailLogo', value, [], null, false);

      doNotify(1, fileUploadedMessage);
    }
  };

  fileUpload = (name, images) => {
    if (_isObject(images) && images.length === 1) {
      const fd = new FormData();
      fd.append('file', images[0]);
      fd.append('logoType', name);

      switch (name) {
        case 'mainLogo':
          this.props.uploadMainLogo(this.props.entity.getId(), fd);
          break;

        case 'mainLogoSvg':
          this.props.uploadMainLogoSvg(this.props.entity.getId(), fd);
          break;

        case 'watermarkLogo':
          this.props.uploadWatermarkLogo(this.props.entity.getId(), fd);
          break;

        case 'watermarkLogoSvg':
          this.props.uploadWatermarkLogoSvg(this.props.entity.getId(), fd);
          break;

        case 'scrollLogo':
          this.props.uploadScrollLogo(this.props.entity.getId(), fd);
          break;

        case 'scrollLogoSvg':
          this.props.uploadScrollLogoSvg(this.props.entity.getId(), fd);
          break;

        case 'mailLogo':
          this.props.uploadMailLogo(this.props.entity.getId(), fd);
          break;
      }
    }
  };

  fileReset = name => {
    this.updateEntity(name, null);
  };

  render() {
    const { entity, entityLoaded, changeEntity, disabled, messages } = this.props;

    let mainLogoUrl;
    let mainLogoSvgUrl;
    let watermarkLogoUrl;
    let watermarkLogoSvgUrl;
    let scrollLogoUrl;
    let scrollLogoSvgUrl;
    let mailLogoUrl;
    if (entityLoaded) {
      if (entity.getMainLogo().getId()) {
        const thumbnail = getThumbFileFromEntity(entity.getMainLogo());
        if (thumbnail) {
          mainLogoUrl = thumbnail.getWebLink();
        }
      }

      if (entity.getMainLogoSvg()) {
        const thumbnail = getThumbFileFromEntity(entity.getMainLogoSvg());
        if (thumbnail) {
          mainLogoSvgUrl = thumbnail.getWebLink();
        }
      }
      if (entity.getWatermarkLogo().getId()) {
        const thumbnail = getThumbFileFromEntity(entity.getWatermarkLogo());
        if (thumbnail) {
          watermarkLogoUrl = thumbnail.getWebLink();
        }
      }

      if (entity.getWatermarkLogoSvg()) {
        const thumbnail = getThumbFileFromEntity(entity.getWatermarkLogoSvg());
        if (thumbnail) {
          watermarkLogoSvgUrl = thumbnail.getWebLink();
        }
      }

      if (entity.getScrollLogo()) {
        const thumbnail = getThumbFileFromEntity(entity.getScrollLogo());
        if (thumbnail) {
          scrollLogoUrl = thumbnail.getWebLink();
        }
      }

      if (entity.getScrollLogoSvg()) {
        const thumbnail = getThumbFileFromEntity(entity.getScrollLogoSvg());
        if (thumbnail) {
          scrollLogoSvgUrl = thumbnail.getWebLink();
        }
      }

      if (entity.getMailLogo()) {
        const thumbnail = getThumbFileFromEntity(entity.getMailLogo());
        if (thumbnail) {
          mailLogoUrl = thumbnail.getWebLink();
        }
      }
    }

    return (
      <div className="clearfix p-b-30">
        {entityLoaded ? (
          <Row>
            <Col xs={12} sm={4}>
              <p className="m-t-15 form-group-title">Logo</p>
              <div className="form-group-attached">
                <FormImageWithPreview
                  label="Main logo"
                  name="mainLogo"
                  url={mainLogoUrl}
                  onChange={this.fileUpload}
                  onReset={this.fileReset}
                  pending={this.props.formStatusMainLogo.pending}
                  disabled={disabled}
                />

                <div className="form-group form-group-default padding-20 sm-padding-10">
                  <FormSwitchery
                    name="useScrollLogo"
                    checked={entity.getUseScrollLogo()}
                    value
                    label={'Use scroll logo'}
                    onChange={this.updateEntity}
                    disabled={disabled}
                  />
                </div>

                {entity.getUseScrollLogo() && (
                  <FormImageWithPreview
                    label="Scroll logo"
                    name="scrollLogo"
                    url={scrollLogoUrl}
                    onChange={this.fileUpload}
                    onReset={this.fileReset}
                    pending={this.props.formStatusScrollLogo.pending}
                    disabled={disabled}
                  />
                )}

                <FormImageWithPreview
                  label={messages.default_logo_size}
                  name="mailLogo"
                  url={mailLogoUrl}
                  onChange={this.fileUpload}
                  onReset={this.fileReset}
                  pending={this.props.formStatusMailLogo.pending}
                  disabled={disabled}
                />
                <FormImageWithPreview
                  label="Watermark logo"
                  name="watermarkLogo"
                  url={watermarkLogoUrl}
                  onChange={this.fileUpload}
                  onReset={this.fileReset}
                  pending={this.props.formStatusWatermarkLogo.pending}
                  disabled={disabled}
                />
              </div>

              <p className="m-t-15 form-group-title">Logo in emails</p>
              <div className="form-group-attached">
                <ButtonToolbar>
                  <ToggleButtonGroup
                    type="radio"
                    name="useMailLogo"
                    defaultValue={entity.getUseMailLogo()}
                    onChange={value => this.updateEntity('useMailLogo', value)}
                  >
                    <ToggleButton value="main" disabled={disabled}>
                      Main Logo
                    </ToggleButton>
                    {entity.getUseScrollLogo() && (
                      <ToggleButton value="scroll" disabled={disabled}>
                        Scroll logo
                      </ToggleButton>
                    )}
                    <ToggleButton value="mail" disabled={disabled}>
                      Mail Logo
                    </ToggleButton>
                  </ToggleButtonGroup>
                </ButtonToolbar>
              </div>
            </Col>
            <Col xs={12} sm={8}>
              <p className="m-t-15">Favicons</p>
              <WhiteLabelFavicons
                entityLoaded={entityLoaded}
                entity={entity}
                changeEntity={changeEntity}
                disabled={disabled}
              />
            </Col>
          </Row>
        ) : null}
      </div>
    );
  }
}
WhiteLabelLogoAndFav.defaultProps = {
  inModal: false,
};

const mapStateToProps = state => {
  return {
    formStatusMainLogo: state.formStatus.whiteLabelMainLogo,
    formStatusMainLogoSvg: state.formStatus.whiteLabelMainLogoSvg,
    formStatusWatermarkLogo: state.formStatus.whiteLabelWatermarkLogo,
    formStatusWatermarkLogoSvg: state.formStatus.whiteLabelWatermarkLogoSvg,
    formStatusScrollLogo: state.formStatus.whiteLabelScrollLogo,
    formStatusScrollLogoSvg: state.formStatus.whiteLabelScrollLogoSvg,
    formStatusMailLogo: state.formStatus.whiteLabelMailLogo,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    uploadMainLogo: (whiteLabelId, args) => {
      formStatusDispatchHelper(
        'whiteLabelMainLogo',
        '/api/whitelabels/' + whiteLabelId + '/logos.json',
        args,
        'post',
        dispatch
      );
    },
    uploadMainLogoSvg: (whiteLabelId, args) => {
      formStatusDispatchHelper(
        'whiteLabelMainLogoSvg',
        '/api/whitelabels/' + whiteLabelId + '/logos.json',
        args,
        'post',
        dispatch
      );
    },
    uploadWatermarkLogo: (whiteLabelId, args) => {
      formStatusDispatchHelper(
        'whiteLabelWatermarkLogo',
        '/api/whitelabels/' + whiteLabelId + '/logos.json',
        args,
        'post',
        dispatch
      );
    },
    uploadWatermarkLogoSvg: (whiteLabelId, args) => {
      formStatusDispatchHelper(
        'whiteLabelWatermarkLogoSvg',
        '/api/whitelabels/' + whiteLabelId + '/logos.json',
        args,
        'post',
        dispatch
      );
    },
    uploadScrollLogo: (whiteLabelId, args) => {
      formStatusDispatchHelper(
        'whiteLabelScrollLogo',
        '/api/whitelabels/' + whiteLabelId + '/logos.json',
        args,
        'post',
        dispatch
      );
    },
    uploadScrollLogoSvg: (whiteLabelId, args) => {
      formStatusDispatchHelper(
        'whiteLabelScrollLogoSvg',
        '/api/whitelabels/' + whiteLabelId + '/logos.json',
        args,
        'post',
        dispatch
      );
    },
    uploadMailLogo: (whiteLabelId, args) => {
      formStatusDispatchHelper(
        'whiteLabelMailLogo',
        '/api/whitelabels/' + whiteLabelId + '/logos.json',
        args,
        'post',
        dispatch
      );
    },
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
  };
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(WhiteLabelLogoAndFav)
);
